import { BasicModel } from '../basic.model';

export class TerritoriesLanguagesModel {
  constructor(
    public id: number = null,
    public country: string = null,
    public languages: BasicModel[] = []
  ) {}

  fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
